import { alpha, Components } from '@mui/material';

export const button: Components = {
  MuiButton: {
    styleOverrides: {
      root: {
        fontFamily: 'CustomFont',
        textTransform: 'inherit',
        fontWeight: 700,
      },
    },
    variants: [
      {
        props: {
          variant: 'contained',
          color: 'primary',
        },
        style: {
          backgroundColor: '#00C0B4',
          color: '#FFFFFF',
          minHeight: '56px',
        },
      },
      {
        props: {
          variant: 'outlined',
          color: 'primary',
        },
        style: {
          backgroundColor: '#FFFFFF',
          color: '#00C0B4',
          border: '1px solid #00C0B4',
          minHeight: '56px',
        },
      },
    ],
  },
  MuiButtonBase: {
    styleOverrides: {
      root: {
        textTransform: 'inherit',
        fontWeight: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
      },
    },
  },
};
